import { ActivityIndicator, SafeAreaView, View, StyleSheet, ScrollView, SectionList, Dimensions, Touchable, TouchableOpacity, Linking, Share, Alert } from 'react-native';
import { Text, IconButton, Divider, FAB, shadow, TextInput, Button, Chip } from 'react-native-paper';

import * as React from 'react';
import { useTheme } from 'react-native-paper';
import { collection, doc, getFirestore, increment, setDoc, updateDoc } from 'firebase/firestore';
import Toast from 'react-native-root-toast';
import Prferances from '../constants/Preferances';
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import Global from "../constants/global";
import DImage from "../components/DImage";
import DDate from "../components/DDate";

let baselist: [] = []
let cy = Global.getYear()
const ccy = "class" + cy
export default function NewStudent({ navigation, route }) {
    // const translate = require('google-translate-api');
    const [focus, setFocus] = React.useState({ [`class${cy}`]: { gr: "", roll: 0, class: "", classId: "" } })
    const [classList, setClassList] = React.useState([])
    const classes = useSelector((state) => state.list.Classes)
    React.useEffect(() => {
        if (classes) {
            const s: [] = []
            classes.map(p => {
                if (p.final) {
                    s.push({ ...p })
                }
            })
            const nnewP = s.sort((a, b) => a?.seq < b?.seq ? -1 : 0)
            setClassList(nnewP)
        }
    }, [classes])
    const { colors } = useTheme();
    const pref = React.useContext(Prferances)
    React.useEffect(() => {
        if (route?.params?.data) {
            const data = route?.params?.data
            if (!data[ccy]) {
                const ab = {
                    class: route?.params?.class ? route?.params?.class : "",
                    classId: route?.params?.classId ? route?.params?.classId : "",
                }
                data[ccy] = ab
            }
            //console.log("data", data)
            setFocus(data)
        }
    }, [route.params])

    // const rf = React.useRef()
    return (
        <ScrollView style={{ flex: 1 }}>

            <View style={{ backgroundColor: colors.background, flex: 1, justifyContent: "center" }}>
                <View style={{ backgroundColor: "white", alignSelf: "stretch" }}>
                    <DImage width={170} uri="https://i.pinimg.com/564x/d2/57/67/d257676b21bfdda5ca88d3b7e4b54d87.jpg" />
                </View>

                <TextInput autoFocus label="Name" value={focus?.name ? focus?.name : ""} onChangeText={(t) => {
                    const f = { ...focus[ccy] }
                    f.name = t
                    const f1 = {}
                    f1[ccy] = f
                    setFocus(p => ({ ...p, name: t, ...f1 }))
                }} />
                
                <TextInput keyboardType="number-pad" label="Roll No" value={focus[ccy]?.roll ? focus[ccy]?.roll + "" : ""} onChangeText={(t) => {
                    const rl = parseInt(t)
                    if (!Number.isNaN(rl)) {
                        const f = { ...focus[ccy] }
                        f.roll = rl
                        const f1 = {}
                        f1[ccy] = f
                        setFocus(p => ({ ...p, ...f1 }))
                    }
                }
                } />
                <TextInput label="GR No." value={focus[ccy]?.gr ? focus[ccy]?.gr : ""} onChangeText={(t) => {
                    const f = { ...focus[ccy] }
                    f.gr = t
                    const f1 = {}
                    f1[ccy] = f
                    setFocus(p => ({ ...p, ...f1 }))
                }} />
                <View style={{ paddingTop: 7, paddingBottom: 7 }}>
                    <DDate label="Birth date"
                        value={focus?.bday}
                        onChange={(d) => {
                            setFocus(p => ({ ...p, bday: d }))
                        }}
                    />
                </View>
                {/* <DCalendar
                    current={focus?.bday}
                    callback={(un, obj, boo) => {
                        if (focus?.bday !== un) {
                            setFocus(p => ({ ...p, bday: un }))
                        }
                    }} /> */}

                <TextInput keyboardType="number-pad" label="Mobile No." value={focus?.mobile ? focus?.mobile : ""} onChangeText={(t) => setFocus(p => ({ ...p, mobile: t }))} />
                <TextInput error={focus?.uid?.length !== 18} keyboardType="number-pad" label="UID No." value={focus?.uid ? focus.uid : ""} onChangeText={
                    (t) => setFocus(p => ({ ...p, uid: t }))
                } />
                <TextInput label="Address" value={focus?.address ? focus?.address : ""} onChangeText={(t) => setFocus(p => ({ ...p, address: t }))} />
                <Text style={{ marginTop: 20 }}>Studying in :</Text>
                <View style={{ flexDirection: "row", flexWrap: "wrap", }}>
                    {classList.map((e, i) =>
                        <Chip style={{ margin: 3 }} selected={focus[ccy]?.classId == e.id} onPress={() => {
                            const f = { ...focus[ccy] }
                            f.class = e.name
                            f.classId = e.id
                            f.div = e?.div ? e?.div : ""
                            const f1 = {}
                            f1[ccy] = f
                            setFocus(p => ({ ...p, ...f1 }))
                        }}>{e.name + (e?.div ? " " + e.div : "")}
                        </Chip>
                    )}
                </View>
                <ScrollView horizontal style={{ marginTop: 10 }}>
                    <View style={{ alignItems: "center", flexDirection: "row" }}>
                        <Text>Stream : </Text>
                        {Global.STREAM.map((e, i) =>
                            <Chip style={{ margin: 2 }} selected={focus[ccy]?.stream == i} onPress={() => {
                                const f = { ...focus[ccy] }
                                f.stream = i
                                const f1 = {}
                                f1[ccy] = f
                                setFocus(p => ({ ...p, ...f1 }))
                            }
                            }>{e}</Chip>
                        )}
                    </View>
                </ScrollView>

                <View style={{ flex: 1, alignItems: "center", flexDirection: "row", marginTop: 40, marginBottom: 60 }}>
                    <Button style={{ flex: 1 }} onPress={() => navigation.goBack()}>Back</Button>
                    <SaveButton navi={navigation} focus={focus} pref={pref} />
                </View>
            </View >
        </ScrollView >
    );


}

const SaveButton = ({ navi, focus, pref }) => {
    const [working, setWorking] = React.useState({ working: false, status: 0 })
    return <Button icon={working.status == 1 ? "check-bold" : working.status == -1 ? "alert" : undefined} style={{ flex: 1 }} loading={working.working} mode="contained" onPress={async () => {
        setWorking(p => ({ ...p, working: true }))
        if (focus?.name && focus[ccy]?.roll) {
            save(focus, pref).then(e => {
                setWorking(p => ({ ...p, working: false, status: e }))
                setTimeout(() => {
                    navi?.goBack()
                }, 1000)
            })
        } else {
            setWorking(p => ({ ...p, working: false, status: -1 }))
            Toast.show("Error : Name અને Rollno  જરૂરી છે")
        }

    }}>Save</Button>
}
async function save(focus, pref) {
    const db = getFirestore()
    let ref
    if (focus?.id) {
        ref = doc(db, Global.STUDENTS, focus.id)
    } else {
        ref = doc(collection(db, Global.STUDENTS))
        focus.id = ref.id
        focus.createdOn = dayjs().unix()
        focus.createdBy = pref?.current?.id
        focus.createdByName = pref?.current?.name
        focus.exam = []
    }
    focus.stamp = dayjs().unix()
    try {
        await setDoc(ref, focus, { merge: true })
        return 1
    } catch {
        return -1
    }
    // setFocus({ classId: focus.classId, class: focus.class })
    // rf?.current?.focus()
}